module.exports = __webpack_public_path__ + "img/icon_cowstanding_colour.d1ac3e95.svg";